import { render, staticRenderFns } from "./relJinhengDialog4.vue?vue&type=template&id=3fe3e86e"
import script from "./relJinhengDialog4.vue?vue&type=script&lang=js"
export * from "./relJinhengDialog4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports